import '@carvana/showroom-css-theme/Theme.css';

import './api/interceptors';

import { ExperimentProvider } from '@carvana/experiment';
import Cookie from '@carvana/stc-cookie';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';

import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './components/LandingPage';
import mfeConfig from './mfeConfig';
import { initializeDataDog } from './shared/datadog';
import ExperimentLoader from './components/ExperimentLoader';

const client = new QueryClient();

initializeDataDog();

const App = () => {
  useEffect(() => {
    mfeConfig();
    const browserCookie = Cookie.getBcId();
    const dev = process.env.NODE_ENV === 'development';
    if (dev && !browserCookie) {
      Cookie.setCookie('BrowserCookieId', '123456789', 30);
    }
  }, []);

  return (
    <ExperimentProvider>
      <QueryClientProvider client={client}>
        <Header />
        <ExperimentLoader>
          <LandingPage />
        </ExperimentLoader>
        <Footer />
      </QueryClientProvider>
    </ExperimentProvider>
  );
};

export default App;
